import { Outlet } from 'react-router';
import { Sidebar } from './sidebar';
import { Header } from './header';
import { PredictionSlip } from '@/features/predictions/components/prediction-slip';

export function DashboardLayout() {
  return (
    <div className="flex min-h-dvh bg-background">
      <a
        href="#main-content"
        className="sr-only fixed left-4 top-4 z-[60] rounded-md bg-primary px-4 py-3 text-primary-foreground focus:not-sr-only"
      >
        Skip to content
      </a>
      <Sidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <Header />
        <main
          id="main-content"
          tabIndex={-1}
          className="mx-auto w-full max-w-content flex-1 px-4 pb-24 pt-6 outline-none sm:px-6 sm:pt-8 lg:px-8"
        >
          <Outlet />
        </main>
      </div>
      <PredictionSlip />
    </div>
  );
}
